<template>
    <div>
        后台管理
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>